import Vue from 'vue'

// 只在当前编辑器实例内保留诊断，不写入大屏配置、资源或浏览器存储。
const hosts = new WeakMap()
function state (host) {
  if (!hosts.has(host)) hosts.set(host, Vue.observable({ entries: {}, viewports: {} }))
  return hosts.get(host)
}
export function mapLocationDiagnostic (host, id) { return state(host).entries[id] }
export function mapViewportReader (host, id) { return id ? state(host).viewports[id] : undefined }
export function registerMapViewport (host, id, read) {
  if (!id) return () => {}
  Vue.set(state(host).viewports, id, read)
  return () => { if (state(host).viewports[id] === read) Vue.delete(state(host).viewports, id) }
}
export function registerMapDiagnostic (host, id, retry) {
  const value = Vue.observable({ status: 'loading', error: '', renderError: '', count: 0, retry })
  Vue.set(state(host).entries, id, value)
  return {
    update (changes) { Object.assign(value, changes) },
    close () { if (state(host).entries[id] === value) Vue.delete(state(host).entries, id) }
  }
}
